import { useStore } from 'zustand';
import { identity } from 'ramda';
import { type DepartureDateStore } from '@/infrastructure/departure-date/store';
import { useDependencies } from '@/scopes/common/infrastructure/dependencies';

export const useDepartureDateStore = () => {
  const { departureDateStore } = useDependencies();
  return useStore(departureDateStore, identity<DepartureDateStore>);
};
